import { Link, useParams } from "react-router-dom";
import { ArrowRight, Megaphone, Activity, Timer } from "lucide-react";

const meta = {
  cheer: { name: "Cheer", icon: Megaphone, blurb: "Build power, precision, and presence. Cheer squad coming soon to Cawston Titans." },
  basketball: { name: "Basketball", icon: Activity, blurb: "Hardwood season on the horizon. Hoops, hustle, and heart." },
  "track-and-field": { name: "Track & Field", icon: Timer, blurb: "Sprint, jump, throw. Track program in development." },
};

export default function ComingSoon() {
  const { sport } = useParams();
  const info = meta[sport] || { name: "More Sports", icon: Megaphone, blurb: "Stay tuned for additional programs." };
  const Icon = info.icon;

  return (
    <div data-testid={`coming-soon-${sport || "page"}`} className="min-h-[70vh] bg-[#F5EFE0] flex items-center px-6 py-24">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-[#2D5F3F] mb-8 shadow-ink-offset">
          <Icon className="w-10 h-10 text-[#FDFBF7]" strokeWidth={2.4} />
        </div>
        <div className="font-display text-xs uppercase tracking-[0.3em] text-[#2D5F3F] font-bold">Coming Soon</div>
        <h1 className="mt-4 font-display text-5xl sm:text-7xl font-black uppercase text-[#0A0A0A] leading-none">{info.name}</h1>
        <p className="mt-6 text-black/75 text-lg leading-relaxed">{info.blurb}</p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link to="/contact" data-testid="coming-soon-contact" className="inline-flex items-center gap-2 bg-[#2D5F3F] hover:bg-[#1B4332] text-[#FDFBF7] font-display uppercase tracking-wider font-extrabold px-6 py-3 transition-colors">
            Get Updates <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/football" data-testid="coming-soon-football" className="inline-flex items-center gap-2 border-2 border-[#2D5F3F] text-[#2D5F3F] hover:bg-[#2D5F3F] hover:text-[#FDFBF7] font-display uppercase tracking-wider font-bold px-6 py-3 transition-colors">
            Football Program
          </Link>
        </div>
      </div>
    </div>
  );
}
